<template>
<div><AboutUsNav></AboutUsNav>
  <div class="aboutwes">
    <!-- <a class="aaaaaa" href="/aboutwe#a" style="font-size: 24px"><div>aaaaaa</div></a> -->
    <div class="aboutwe">

      <div
        id="c"
        class="aboutwe_container about-fw"
      >
        <h3 class="about-h3-fw">服务内容</h3>
        <div>
          <img
            src="@/assets/images/About_Three.png"
            alt=""
            class="about-fw-img"
          >
        </div>
        <div class="xzzc">
          <div class="about-fw-t1">
            <span style="font-size: 24px;">闲置资产 快速变现</span><br><br><br>
            <span>线上+线下的拍卖模式: 线上拍卖，线下预展。帮助企业中的闲置资产：二手设备、废旧物资、土地房产、工程机械、车辆房产、库存积压等通过竞价的方式实现快速变现。</span><br><br><br>
          </div>
          <div style="margin-left:36px;margin-right:20px;">
            <span style="font-size: 24px; ">有形无形 价格评估</span><br><br><br>
            <span>对有形资产，无形资产在特定点的价值（价格）进行分析、测算和判断并提供专业的意见和建议，保障委托人的利益。</span><br><br><br>
          </div>
          <div style="margin-left:36px;margin-right:20px;">
            <span style="font-size: 24px;">法律咨询 交易保障</span><br><br><br>
            <span>公司的法务部门，对于合同签署、相关资料、其他证明等，公司法务严格审核，并解决委托人，竞买人，买受人提出的法律相关的问题，对于向上支付，线下交易也会保障双方的利益.</span>
          </div>
        </div>

        <div class="ico1">
          <img
            style="width: 96px;height: 96px;"
            src="@/assets/images/About_b1.png"
          >
          <span></span>
        </div>
        <div class="ico2">
          <img
            style="width: 96px;height: 96px;"
            src="@/assets/images/About_b2.png"
          >
          <span></span>
        </div>
        <div class="ico3">
          <img
            style="width: 96px;height: 96px;"
            src="@/assets/images/About_b3.png"
          >
          <span></span>
        </div>

      </div>

    </div>
  </div>
</div>
</template>

<script>
// import { formatDate } from '@/assets/js/date.js'
import AboutUsNav from '@/components/AboutUsNav.vue';
export default {
  metaInfo: {
    title: "拍界——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }, {
      name: "description",
      content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }]
  },
  data () {
    return {
      subjects: [],
      //分页器
      paginator: {
        first: null,
        before: null,
        previous: null,
        current: 1,
        last: null,
        next: null,
        total_pages: null,
        total_items: null,
        limit: 20,
      },
    }
  },

  created () {
    // 显示公共栏
    this.$emit('header', true)
    this.$emit('footer', true)

    // 加载路由参数
    this.getRouteQuery()
    // 请求列表数据
    this.getSubjects()

    // 页面至顶部
    window.scrollTo(0, 0);
  },
  components: {
    AboutUsNav
  }


}
</script>